import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import SessionStorage from 'libs/SessionStorage';
import OidcService from 'services/OidcService';
import Account, { ConfirmEmail, SignIn, SignUp } from 'modules/Account';
import App from 'modules/App';
import { LogoLayout, LogoMobileLayout, SignInLayout } from 'modules/Layout';
async function action({ route, query, store, getUrl }) {
    let Component;
    let redirect = null;
    if (process.env.BROWSER) {
        const user = await OidcService.getUser();
        if (!user) {
            const state = store.getState();
            const isMobileDisplayMode = App.selectors.isMobileDisplayMode(state);
            const CurrentLogoLayout = isMobileDisplayMode ? LogoMobileLayout : LogoLayout;
            const returnUrl = query.ReturnUrl;
            if (returnUrl) {
                const url = new URL(returnUrl);
                const clientId = url.searchParams.get('client_id');
                const clientAppKey = clientId.split('-')[0];
                const prompt = url.searchParams.get('prompt');
                if (clientId) {
                    try {
                        await store.dispatch(App.actions.fetchIDPClient(clientId)).catch(()=>{});
                    } catch (err) {
                    // handle in saga
                    }
                }
                if (prompt === 'confirmEmail') {
                    const countryCode = SessionStorage.getItem('confirmCountryCode');
                    const token = SessionStorage.getItem('confirmToken');
                    Component = /*#__PURE__*/ _jsx(CurrentLogoLayout, {
                        isNoInit: !!returnUrl,
                        children: /*#__PURE__*/ _jsx(ConfirmEmail, {
                            countryCode: countryCode,
                            token: token,
                            returnUrl: returnUrl
                        })
                    });
                    if (token) {
                        redirect = `${getUrl('confirm-email', {
                            countryCode,
                            token
                        })}?ReturnUrl=${encodeURIComponent(returnUrl)}`;
                        SessionStorage.removeItem('confirmCountryCode');
                        SessionStorage.removeItem('confirmToken');
                    }
                } else if (prompt === 'create') {
                    redirect = `${getUrl('sign-up')}?ReturnUrl=${encodeURIComponent(returnUrl)}`;
                    Component = /*#__PURE__*/ _jsx(CurrentLogoLayout, {
                        isNoInit: !!returnUrl,
                        children: /*#__PURE__*/ _jsx(SignUp, {
                            returnUrl: returnUrl
                        })
                    });
                } else {
                    Component = /*#__PURE__*/ _jsx(SignIn, {
                        SignInLayout: SignInLayout,
                        LogoLayout: CurrentLogoLayout,
                        returnUrl: returnUrl,
                        clientAppKey: clientAppKey
                    });
                }
            } else {
                Component = /*#__PURE__*/ _jsx(SignIn, {
                    SignInLayout: SignInLayout,
                    LogoLayout: CurrentLogoLayout,
                    clientAppKey: "aid"
                });
            }
            if (SessionStorage.getItem('invitationToken')) {
                try {
                    await store.dispatch(Account.actions.setInvitation()).catch(()=>{});
                } catch (err) {
                // handle in saga
                }
            }
        } else {
            redirect = getUrl('app-catalog');
        }
    }
    return {
        chunks: [
            'account'
        ],
        name: route.name,
        redirect,
        component: Component
    };
}
export default action;
